/**
 * GeChiUI dependencies
 */
import { __ } from '@gechiui/i18n';
import { Icon, blockDefault } from '@gechiui/icons';

function InserterNoResults() {
	return (
		<div className="block-editor-inserter__no-results">
			<Icon
				className="block-editor-inserter__no-results-icon"
				icon={ blockDefault }
			/>
			<p>{ __( 'No results found.' ) }</p>
		</div>
	);
}

export default InserterNoResults;
